import { Result } from '@hitiq/generic';
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { awsConfig } from '../../aws-exports';

export const regionThunk = createAsyncThunk(
  'region/loadLocalRegionThunk',
  async (payload, thunkAPI): Promise<boolean | any> => {
    try {
      const results = await fetch(awsConfig.aws_appsync_geoIpEndpoint);
      return await results.json();
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        heading: 'Unable to load local region',
        message: error.error.message,
        severity: 'error',
        id: uuidv4(),
      });
    }
  },
);
